import { render, staticRenderFns } from "./TrustReviewAndConfirm.vue?vue&type=template&id=4562ea2a&scoped=true"
import script from "./TrustReviewAndConfirm.vue?vue&type=script&lang=js"
export * from "./TrustReviewAndConfirm.vue?vue&type=script&lang=js"
import style0 from "./TrustReviewAndConfirm.vue?vue&type=style&index=0&id=4562ea2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4562ea2a",
  null
  
)

export default component.exports